import { render } from "./z-blocker-modal.vue?vue&type=template&id=1ca4825a"
import script from "./z-blocker-modal.vue?vue&type=script&lang=js"
export * from "./z-blocker-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__